module.exports = __webpack_public_path__ + "img/20191218154313360截图20191218105608917.9be8489a.jpg";